export default function reportPackageReportDirective() {
  return {
    template: require('./report-package-report.html'),
    controller: 'PRReportPackageReportController',
    controllerAs: 'prReportPackageReportVM',
    bindToController: true,
    replace: true,
    scope: {
      customerId: '@',
      reportPackageReport: '=',
    },
  };
}
